"use strict";
import $ from "jquery";
import _ from "underscore";
import ApiService from "../services/api_service";
var failureMessage = "Settings failed to load. Please refresh your browser to try again.";
var FeaturesService = {
  features: {},
  updateFeatures: function(features) {
    this.features = features;
    Promise.resolve(features);
  },
  ready: _.once(function() {
    return Promise.resolve().then(() => loadFeatures());
  })
};
var loadFeatures = function() {
  ApiService.addErrorHandler(
    // TODO: use fetch instead
    // eslint-disable-next-line no-restricted-syntax
    $.ajax({ url: "/api/features", type: "get", cache: false }),
    failureMessage,
    { caller: "FeaturesService.loadFeatures" }
  ).then(function(data) {
    FeaturesService.updateFeatures(data);
    return data;
  });
};
export default FeaturesService;
